.container {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  height: 100%;
}
